module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "center",
    attrs: {
      "id": "TOC"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Publisher"
    }
  }, [_vm._v("Publisher’s Note")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/6chap1#chap1"
    }
  }, [_c('i', [_vm._v("Remember?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/7chap2#chap2"
    }
  }, [_c('i', [_vm._v("These Mornings of Rain")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/8chap3#chap3"
    }
  }, [_c('i', [_vm._v("First, They Said")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/9chap4#chap4"
    }
  }, [_c('i', [_vm._v("Listen")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/10chap5#chap5"
    }
  }, [_c('i', [_vm._v("S M")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/11chap6#chap6"
    }
  }, [_c('i', [_vm._v("The Diamonds on Liz’s Bosom")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/12chap7#chap7"
    }
  }, [_c('i', [_vm._v("We Alone")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/13chap8#chap8"
    }
  }, [_c('i', [_vm._v("Attentiveness")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/14chap9#chap9"
    }
  }, [_c('i', [_vm._v("1971")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/15chap10#chap10"
    }
  }, [_c('i', [_vm._v("Every Morning")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/16chap11#chap11"
    }
  }, [_c('i', [_vm._v("How Poems Are Made / A Discredited View")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/17chap12#chap12"
    }
  }, [_c('i', [_vm._v("Mississippi Winter I")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/18chap13#chap13"
    }
  }, [_c('i', [_vm._v("Mississippi Winter II")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/19chap14#chap14"
    }
  }, [_c('i', [_vm._v("Mississippi Winter III")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/20chap15#chap15"
    }
  }, [_c('i', [_vm._v("Mississippi Winter IV")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/21chap16#chap16"
    }
  }, [_c('i', [_vm._v("love is not concerned")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/22chap17#chap17"
    }
  }, [_c('i', [_vm._v("She said:")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/23chap18#chap18"
    }
  }, [_c('i', [_vm._v("Walker")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/24chap19#chap19"
    }
  }, [_c('i', [_vm._v("Killers")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/25chap20#chap20"
    }
  }, [_c('i', [_vm._v("Songless")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/26chap21#chap21"
    }
  }, [_c('i', [_vm._v("A Few Sirens")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/27chap22#chap22"
    }
  }, [_c('i', [_vm._v("Poem at Thirty-nine")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/28chap23#chap23"
    }
  }, [_c('i', [_vm._v("I Said to Poetry")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/29chap24#chap24"
    }
  }, [_c('i', [_vm._v("Gray")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/30chap25#chap25"
    }
  }, [_c('i', [_vm._v("Overnights")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/31chap26#chap26"
    }
  }, [_c('i', [_vm._v("My Daughter Is Coming!")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/32chap27#chap27"
    }
  }, [_c('i', [_vm._v("When Golda Meir Was in Africa")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/33chap28#chap28"
    }
  }, [_c('i', [_vm._v("If “Those People” Like You")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/34chap29#chap29"
    }
  }, [_c('i', [_vm._v("On Sight")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/35chap30#chap30"
    }
  }, [_c('i', [_vm._v("I’m Really Very Fond")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/36chap31#chap31"
    }
  }, [_c('i', [_vm._v("Representing the Universe")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/38chap32#chap32"
    }
  }, [_c('i', [_vm._v("Family Of")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/39chap33#chap33"
    }
  }, [_c('i', [_vm._v("Each One, Pull One")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/40chap34#chap34"
    }
  }, [_c('i', [_vm._v("Who?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/41chap35#chap35"
    }
  }, [_c('i', [_vm._v("Without Commercials")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/42chap36#chap36"
    }
  }, [_c('i', [_vm._v("No One Can Watch the Wasichu")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/43chap37#chap37"
    }
  }, [_c('i', [_vm._v("The Thing Itself")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/44chap38#chap38"
    }
  }, [_c('i', [_vm._v("Torture")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/45chap39#chap39"
    }
  }, [_c('i', [_vm._v("Well.")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/46chap40#chap40"
    }
  }, [_c('i', [_vm._v("Song")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/47chap41#chap41"
    }
  }, [_c('i', [_vm._v("These Days")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/48biography#biography"
    }
  }, [_vm._v("A Biography of Alice Walker")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-353dcd8a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/4-TOC.vue
// module id = 69
// module chunks = 0